import React, { memo, CSSProperties, useMemo } from 'react';
import { R } from '@core/utils/r';
import { UncontrolledTooltip } from 'reactstrap';

export interface HotnessProps {
  children: number;
  tooltip?: string;
  style?: CSSProperties;
  container?: string;
}

export const Hotness = memo((props: HotnessProps) => {
  const { style, children, tooltip } = props;
  const number = useMemo(() => R.random(10, 99999), []);
  return (
    <div style={style} id={`hotness-${number}`}>
      {R.times(children).map((_, index) => (
        <i key={index} style={{ color: 'red' }} className="fas fa-fire mr-1"></i>
      ))}
      {!R.isEmpty(tooltip) && (
        <UncontrolledTooltip container={props.container} placement="top" target={`hotness-${number}`}>
          {tooltip}
        </UncontrolledTooltip>
      )}
    </div>
  );
});
